import { render, staticRenderFns } from "./fromSafesTransfers.vue?vue&type=template&id=4bcad8c8"
import script from "./fromSafesTransfers.vue?vue&type=script&lang=js"
export * from "./fromSafesTransfers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports